export default "__VITE_ASSET__B9WC$Hhc__"